import React, { useState, useEffect } from 'react';
import { trackPageView } from '../services/analytics';

const HomePage = ({ onGoToLogin, onGoToRegister, onGoToAdmin, onGoToPricing, onGoToConfidentialite }) => {
  const [activeDemoDoc, setActiveDemoDoc] = useState(null);
  const [demoStep, setDemoStep] = useState('idle'); // 'idle' | 'scanning' | 'success'
  const [extractedData, setExtractedData] = useState(null);

  useEffect(() => {
    trackPageView('landing');
  }, []);

  const demoDocuments = {
    edf: {
      name: 'Facture Électricité EDF',
      vendor: 'EDF France S.A.',
      ht: '124.50 €',
      tva: '24.90 € (20%)',
      ttc: '149.40 €',
      category: 'Énergie & Services',
      pcg: '6061 (Fournitures non stockables)'
    },
    amazon: {
      name: 'Achat Matériel Amazon',
      vendor: 'Amazon Web Services',
      ht: '450.00 €',
      tva: '90.00 € (20%)',
      ttc: '540.00 €',
      category: 'Matériel & Logiciel',
      pcg: '6063 (Petits équipements)'
    },
    restaurant: {
      name: 'Note de Frais Déjeuner',
      vendor: 'Le Bistrot Parisien',
      ht: '35.00 €',
      tva: '3.50 € (10%)',
      ttc: '38.50 €',
      category: 'Déplacements & Repas',
      pcg: '6257 (Réceptions et congrès)'
    }
  };

  const startDemoScan = (docKey) => {
    setActiveDemoDoc(docKey);
    setDemoStep('scanning');
    setExtractedData(null);
  };

  useEffect(() => {
    if (demoStep === 'scanning') {
      const timer = setTimeout(() => {
        setDemoStep('success');
        setExtractedData(demoDocuments[activeDemoDoc]);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [demoStep, activeDemoDoc]);

  return (
    <div style={{ minHeight: '100vh', background: '#F8FAFC', color: '#0F172A', fontFamily: 'Inter, system-ui, sans-serif', overflowX: 'hidden' }}>
      
      {/* Balise style pour les overrides media queries de réactivité mobile */}
      <style>{`
        @media (max-width: 768px) {
          .nav-links {
            display: none !important;
          }
          .main-header {
            padding: 12px 16px !important;
          }
          .hero-section {
            padding: 40px 16px 60px !important;
            gap: 32px !important;
          }
          .hero-section h1 {
            font-size: 32px !important;
          }
          .hero-section p {
            font-size: 15px !important;
          }
          .features-section {
            padding: 60px 16px !important;
          }
          .features-section h2 {
            font-size: 28px !important;
          }
          .demo-section {
            padding: 60px 16px !important;
          }
          .demo-section h2 {
            font-size: 28px !important;
          }
          .pricing-section {
            padding: 60px 16px !important;
          }
          .pricing-section h2 {
            font-size: 28px !important;
          }
          .footer-section {
            padding: 40px 16px !important;
          }
          .metrics-divider {
            display: none !important;
          }
          .metrics-container {
            gap: 16px 24px !important;
          }
        }
      `}</style>

      {/* 1. HEADER / NAVIGATION */}
      <header className="main-header" style={{
        position: 'sticky', top: 0, zIndex: 1000, background: 'rgba(248, 250, 252, 0.8)', 
        backdropFilter: 'blur(12px)', borderBottom: '1px solid #E2E8F0', padding: '16px 40px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{
            width: '36px', height: '36px', borderRadius: '10px', background: 'linear-gradient(135deg, #1D9E75, #10B981)',
            color: 'white', fontSize: '18px', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            C
          </div>
          <span style={{ fontSize: '20px', fontWeight: '700', letterSpacing: '-0.5px', color: '#0F172A' }}>ComptaAI</span>
        </div>

        <nav className="nav-links" style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
          <a href="#features" style={{ fontSize: '14px', fontWeight: '500', color: '#475569', textDecoration: 'none', transition: 'color 0.2s' }}
             onMouseEnter={(e) => e.target.style.color = '#1D9E75'} onMouseLeave={(e) => e.target.style.color = '#475569'}>Fonctionnalités</a>
          <a href="#demo" style={{ fontSize: '14px', fontWeight: '500', color: '#475569', textDecoration: 'none', transition: 'color 0.2s' }}
             onMouseEnter={(e) => e.target.style.color = '#1D9E75'} onMouseLeave={(e) => e.target.style.color = '#475569'}>Démo</a>
          <a href="#pricing" style={{ fontSize: '14px', fontWeight: '500', color: '#475569', textDecoration: 'none', transition: 'color 0.2s' }}
             onMouseEnter={(e) => e.target.style.color = '#1D9E75'} onMouseLeave={(e) => e.target.style.color = '#475569'}>Tarifs</a>
          <button onClick={onGoToAdmin} style={{ background: 'none', border: 'none', fontSize: '13px', color: '#64748B', cursor: 'pointer', transition: 'color 0.2s' }}
                  onMouseEnter={(e) => e.target.style.color = '#0F172A'} onMouseLeave={(e) => e.target.style.color = '#64748B'}>Espace Admin</button>
        </nav>

        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button 
            onClick={onGoToLogin} 
            style={{
              padding: '10px 20px', background: 'none', border: 'none', color: '#475569', 
              fontSize: '14px', fontWeight: '600', cursor: 'pointer', transition: 'color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.color = '#1D9E75'}
            onMouseLeave={(e) => e.target.style.color = '#475569'}
          >
            Se connecter
          </button>
          <button 
            onClick={onGoToRegister} 
            style={{
              padding: '10px 20px', background: 'linear-gradient(135deg, #1D9E75, #10B981)', 
              color: 'white', border: 'none', borderRadius: '10px', fontSize: '14px', 
              fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s',
              boxShadow: '0 4px 12px rgba(29, 158, 117, 0.15)'
            }}
            onMouseEnter={(e) => { e.target.style.transform = 'translateY(-1px)'; e.target.style.boxShadow = '0 6px 16px rgba(29, 158, 117, 0.25)'; }}
            onMouseLeave={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 4px 12px rgba(29, 158, 117, 0.15)'; }}
          >
            Essai gratuit
          </button>
        </div>
      </header>

      {/* 2. HERO SECTION */}
      <section className="hero-section" style={{ display: 'flex', flexWrap: 'wrap', padding: '80px 40px 100px', maxWidth: '1200px', margin: '0 auto', gap: '40px', alignItems: 'center' }}>
        
        {/* Left Column */}
        <div style={{ flex: '1 1 500px', display: 'flex', flexDirection: 'column', gap: '24px' }}>
          <div style={{
            alignSelf: 'flex-start', display: 'flex', alignItems: 'center', gap: '8px',
            background: '#E1F5EE', padding: '6px 12px', borderRadius: '20px', border: '1px solid #A7F3D0'
          }}>
            <span style={{ fontSize: '12px', color: '#0F6E56', fontWeight: 'bold' }}>✨ NOUVELLE VERSION 2.0</span>
          </div>

          <h1 style={{ fontSize: '52px', fontWeight: '800', lineHeight: '1.15', letterSpacing: '-1.5px', color: '#0F172A' }}>
            Pilotez votre comptabilité d'une main de maître grâce à <span style={{ color: '#1D9E75', background: 'linear-gradient(to right, #1D9E75, #10B981)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>l'IA</span>.
          </h1>

          <p style={{ fontSize: '18px', color: '#475569', lineHeight: '1.6', maxWidth: '540px' }}>
            Assistant comptable en ligne de nouvelle génération. Déposez vos factures, l'intelligence artificielle extrait vos écritures et calcule votre TVA instantanément dans un espace 100% sécurisé et étanche.
          </p>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginTop: '12px' }}>
            <button 
              onClick={onGoToRegister} 
              style={{
                padding: '16px 36px', background: 'linear-gradient(135deg, #1D9E75, #10B981)', 
                color: 'white', border: 'none', borderRadius: '12px', fontSize: '16px', 
                fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s',
                boxShadow: '0 4px 12px rgba(29, 158, 117, 0.2)'
              }}
              onMouseEnter={(e) => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 6px 20px rgba(29, 158, 117, 0.3)'; }}
              onMouseLeave={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 4px 12px rgba(29, 158, 117, 0.2)'; }}
            >
              Créer mon compte
            </button>
            <button 
              onClick={onGoToLogin} 
              style={{
                padding: '16px 36px', background: 'white', color: '#0F172A', 
                border: '1px solid #E2E8F0', borderRadius: '12px', fontSize: '16px', 
                fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s',
                boxShadow: '0 4px 12px rgba(0,0,0,0.02)'
              }}
              onMouseEnter={(e) => { e.target.style.transform = 'translateY(-2px)'; e.target.style.background = '#F8FAFC'; }}
              onMouseLeave={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.background = 'white'; }}
            >
              Se connecter
            </button>
          </div>

          <div className="metrics-container" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '20px', marginTop: '16px', borderTop: '1px solid #E2E8F0', paddingTop: '24px' }}>
            <div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#0F172A' }}>99%</div>
              <div style={{ fontSize: '12px', color: '#64748B' }}>Précision de lecture</div>
            </div>
            <div className="metrics-divider" style={{ width: '1px', height: '30px', background: '#E2E8F0' }}></div>
            <div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#0F172A' }}>&lt; 2s</div>
              <div style={{ fontSize: '12px', color: '#64748B' }}>Temps d'extraction</div>
            </div>
            <div className="metrics-divider" style={{ width: '1px', height: '30px', background: '#E2E8F0' }}></div>
            <div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#0F172A' }}>100%</div>
              <div style={{ fontSize: '12px', color: '#64748B' }}>Isolation de données</div>
            </div>
          </div>
        </div>

        {/* Right Column - Premium CSS Mockup */}
        <div style={{ flex: '1 1 500px', display: 'flex', justifyContent: 'center' }}>
          <div style={{
            width: '100%', maxWidth: '480px', background: 'white', borderRadius: '24px', 
            border: '1px solid #E2E8F0', padding: '24px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
            position: 'relative'
          }}>
            {/* Header Mockup */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', borderBottom: '1px solid #F1F5F9', paddingBottom: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#EF4444' }}></span>
                <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#F59E0B' }}></span>
                <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#10B981' }}></span>
              </div>
              <div style={{ fontSize: '12px', color: '#64748B', background: '#F1F5F9', padding: '4px 12px', borderRadius: '10px' }}>Espace Comptable</div>
            </div>

            {/* Simulated Data */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              
              {/* Stat card */}
              <div style={{ background: '#FAFDFB', border: '1px solid #E1F5EE', borderRadius: '16px', padding: '16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ fontSize: '12px', color: '#0F6E56', fontWeight: '600' }}>TVA Trimestre Actuel</div>
                  <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#0F172A', marginTop: '4px' }}>1 432.50 €</div>
                </div>
                <div style={{ fontSize: '20px', padding: '8px', background: '#E1F5EE', borderRadius: '10px' }}>📈</div>
              </div>

              {/* Transactions List Simulation */}
              <div>
                <div style={{ fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '10px' }}>Dernières Pièces</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyItems: 'space-between', padding: '10px', background: '#F8FAFC', borderRadius: '12px', border: '1px solid #F1F5F9' }}>
                    <span style={{ fontSize: '16px', marginRight: '10px' }}>📄</span>
                    <div>
                      <div style={{ fontSize: '12px', fontWeight: '600', color: '#0F172A' }}>Facture AWS Cloud</div>
                      <div style={{ fontSize: '10px', color: '#64748B' }}>Aujourd'hui, 14:32</div>
                    </div>
                    <span style={{ marginLeft: 'auto', fontSize: '12px', fontWeight: 'bold', color: '#0F172A' }}>150.00 €</span>
                  </div>
                  
                  <div style={{ display: 'flex', alignItems: 'center', justifyItems: 'space-between', padding: '10px', background: '#F8FAFC', borderRadius: '12px', border: '1px solid #F1F5F9' }}>
                    <span style={{ fontSize: '16px', marginRight: '10px' }}>📄</span>
                    <div>
                      <div style={{ fontSize: '12px', fontWeight: '600', color: '#0F172A' }}>Abonnement Adobe Creative</div>
                      <div style={{ fontSize: '10px', color: '#64748B' }}>Hier, 11:15</div>
                    </div>
                    <span style={{ marginLeft: 'auto', fontSize: '12px', fontWeight: 'bold', color: '#0F172A' }}>59.99 €</span>
                  </div>
                </div>
              </div>

              {/* Chat Simulation */}
              <div style={{ borderTop: '1px solid #F1F5F9', paddingTop: '16px', display: 'flex', gap: '10px' }}>
                <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: '#1D9E75', color: 'white', fontSize: '12px', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>🤖</div>
                <div style={{ background: '#FAF9F5', border: '1px solid #E8E7E3', borderRadius: '12px', padding: '10px 14px', fontSize: '12px', color: '#475569', lineHeight: '1.4' }}>
                  J'ai extrait la facture AWS : 150.00 € HT + 30.00 € de TVA (20%). Souhaitez-vous valider son écriture en compte 626 ?
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. FEATURES SECTION */}
      <section id="features" className="features-section" style={{ background: 'white', padding: '100px 40px', borderTop: '1px solid #E2E8F0', borderBottom: '1px solid #E2E8F0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 style={{ fontSize: '36px', fontWeight: '800', color: '#0F172A', letterSpacing: '-1px' }}>Pourquoi choisir ComptaAI ?</h2>
            <p style={{ fontSize: '16px', color: '#64748B', marginTop: '10px', maxWidth: '600px', margin: '10px auto 0' }}>
              Une solution pensée pour les entrepreneurs, freelances et TPE. Gagnez du temps grâce à l'intelligence artificielle tout en gardant vos données 100% confidentielles.
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px' }}>
            
            {/* Feature 1 - Multi-taux & Mémoire Tiers */}
            <div style={{ border: '1px solid #E2E8F0', borderRadius: '16px', padding: '32px', transition: 'all 0.3s', background: '#F8FAFC' }}
                 onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.borderColor = '#1D9E75'; e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.03)'; }}
                 onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = '#E2E8F0'; e.currentTarget.style.boxShadow = 'none'; }}>
              <div style={{ fontSize: '24px', marginBottom: '16px', background: '#E1F5EE', display: 'inline-block', padding: '10px', borderRadius: '10px', color: '#1D9E75' }}>👥</div>
              <div style={{ display: 'inline-block', marginLeft: '8px', background: '#DCFCE7', color: '#166534', fontSize: '11px', fontWeight: '700', padding: '2px 8px', borderRadius: '6px' }}>NOUVEAU</div>
              <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#0F172A', marginBottom: '12px', marginTop: '8px' }}>Mémoire Tiers & Clients Récurrents</h3>
              <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.6' }}>
                Rappel automatique de vos clients et fournisseurs habituels. Vos formulaires et comptes comptables se pré-remplissent instantanément à chaque saisie.
              </p>
            </div>

            {/* Feature 2 - Factur-X & Réforme 2026/2027 */}
            <div style={{ border: '1px solid #E2E8F0', borderRadius: '16px', padding: '32px', transition: 'all 0.3s', background: '#F8FAFC' }}
                 onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.borderColor = '#1D9E75'; e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.03)'; }}
                 onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = '#E2E8F0'; e.currentTarget.style.boxShadow = 'none'; }}>
              <div style={{ fontSize: '24px', marginBottom: '16px', background: '#EFF6FF', display: 'inline-block', padding: '10px', borderRadius: '10px', color: '#2563EB' }}>🏛️</div>
              <div style={{ display: 'inline-block', marginLeft: '8px', background: '#DBEAFE', color: '#1E40AF', fontSize: '11px', fontWeight: '700', padding: '2px 8px', borderRadius: '6px' }}>CONFORME 2026</div>
              <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#0F172A', marginBottom: '12px', marginTop: '8px' }}>Facturation normée Factur-X & e-Reporting</h3>
              <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.6' }}>
                Émettez des factures certifiées avec empreinte SHA-256 inaltérable. Télétransmission au Portail Public et export e-Reporting conforme DGFiP.
              </p>
            </div>

            {/* Feature 3 - Cash-Flow & Alertes Trésorerie */}
            <div style={{ border: '1px solid #E2E8F0', borderRadius: '16px', padding: '32px', transition: 'all 0.3s', background: '#F8FAFC' }}
                 onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.borderColor = '#1D9E75'; e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.03)'; }}
                 onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = '#E2E8F0'; e.currentTarget.style.boxShadow = 'none'; }}>
              <div style={{ fontSize: '24px', marginBottom: '16px', background: '#FEF3C7', display: 'inline-block', padding: '10px', borderRadius: '10px', color: '#D97706' }}>📈</div>
              <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#0F172A', marginBottom: '12px' }}>Prévisions Trésorerie & Alertes Seuil</h3>
              <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.6' }}>
                Visualisez vos flux financiers réels et projetés sur 3 mois. Configurez vos seuils d'alerte personnalisés pour réagir avant tout découvert.
              </p>
            </div>

            {/* Feature 4 - Rapprochement Bancaire & Copilote IA */}
            <div style={{ border: '1px solid #E2E8F0', borderRadius: '16px', padding: '32px', transition: 'all 0.3s', background: '#F8FAFC' }}
                 onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.borderColor = '#1D9E75'; e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.03)'; }}
                 onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = '#E2E8F0'; e.currentTarget.style.boxShadow = 'none'; }}>
              <div style={{ fontSize: '24px', marginBottom: '16px', background: '#F3E8FF', display: 'inline-block', padding: '10px', borderRadius: '10px', color: '#9333EA' }}>🤖</div>
              <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#0F172A', marginBottom: '12px' }}>Rapprochement Bancaire & Copilote</h3>
              <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.6' }}>
                Rapprochement automatique de vos relevés de comptes avec vos justificatifs. Posez vos questions fiscales à votre assistant virtuel 24/7.
              </p>
            </div>

            {/* Feature 5 - Sécurité Renforcée */}
            <div style={{ border: '1px solid #E2E8F0', borderRadius: '16px', padding: '32px', transition: 'all 0.3s', background: '#F8FAFC' }}
                 onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.borderColor = '#1D9E75'; e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.03)'; }}
                 onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = '#E2E8F0'; e.currentTarget.style.boxShadow = 'none'; }}>
              <div style={{ fontSize: '24px', marginBottom: '16px', background: '#FCEBEB', display: 'inline-block', padding: '10px', borderRadius: '10px', color: '#EF4444' }}>🔒</div>
              <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#0F172A', marginBottom: '12px' }}>Sécurité & Protection Haute-Fidélité</h3>
              <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.6' }}>
                Espaces de données strictement étanches par entreprise, protection anti-brute-force permanente et en-têtes HTTP de sécurité avancés.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* 4. INTERACTIVE DEMO / OCR SIMULATOR */}
      <section id="demo" className="demo-section" style={{ padding: '100px 40px', maxWidth: '1000px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
          <h2 style={{ fontSize: '36px', fontWeight: '800', color: '#0F172A', letterSpacing: '-1px' }}>Essayez la lecture automatique ComptaAI</h2>
          <p style={{ fontSize: '16px', color: '#64748B', marginTop: '10px' }}>
            Sélectionnez une facture ci-dessous pour voir l'intelligence artificielle travailler en temps réel.
          </p>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px' }}>
          {/* Doc selection column */}
          <div style={{ flex: '1 1 300px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{ fontWeight: '700', fontSize: '14px', color: '#475569', marginBottom: '6px' }}>1. Choisissez un document type :</div>
            
            {Object.keys(demoDocuments).map(key => (
              <button
                key={key}
                onClick={() => startDemoScan(key)}
                style={{
                  width: '100%', padding: '16px 20px', borderRadius: '12px', border: activeDemoDoc === key ? '2px solid #1D9E75' : '1px solid #E2E8F0',
                  background: activeDemoDoc === key ? '#E1F5EE' : 'white', color: '#0F172A', 
                  fontSize: '14px', fontWeight: '600', cursor: 'pointer', textAlign: 'left', transition: 'all 0.2s',
                  display: 'flex', alignItems: 'center', gap: '10px'
                }}
              >
                <span>📄</span>
                {demoDocuments[key].name}
              </button>
            ))}
          </div>

          {/* Interactive display column */}
          <div style={{
            flex: '1.5 1 400px', background: '#0F172A', borderRadius: '16px', padding: '24px', 
            color: '#10B981', fontFamily: 'monospace', minHeight: '300px', display: 'flex', 
            flexDirection: 'column', border: '1px solid #1E293B', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.3)'
          }}>
            {demoStep === 'idle' && (
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#64748B', textAlign: 'center' }}>
                <span style={{ fontSize: '40px', marginBottom: '10px' }}>⚡</span>
                <div>En attente de document... Sélectionnez un document à gauche pour lancer l'analyse.</div>
              </div>
            )}

            {demoStep === 'scanning' && (
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '12px' }}>
                <div>&gt; Réception du document... OK</div>
                <div>&gt; Lecture et reconnaissance en cours...</div>
                <div style={{ width: '100%', height: '4px', background: '#1E293B', borderRadius: '2px', overflow: 'hidden' }}>
                  <div style={{
                    width: '60%', height: '100%', background: '#10B981', 
                    animation: 'pulse 1s infinite alternate' 
                  }} className="progress-bar"></div>
                </div>
                <div>&gt; Extraction des montants et informations fiscales...</div>
              </div>
            )}

            {demoStep === 'success' && extractedData && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', height: '100%' }}>
                <div style={{ color: '#F1F5F9', borderBottom: '1px solid #1E293B', paddingBottom: '10px', fontWeight: 'bold' }}>
                  [RÉSULTATS DE L'ANALYSE COMPTAAI]
                </div>
                
                <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: '8px 16px', fontSize: '13px' }}>
                  <span style={{ color: '#64748B' }}>Fournisseur :</span>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>{extractedData.vendor}</span>

                  <span style={{ color: '#64748B' }}>Montant HT :</span>
                  <span style={{ color: '#F1F5F9' }}>{extractedData.ht}</span>

                  <span style={{ color: '#64748B' }}>Montant TVA :</span>
                  <span style={{ color: '#F1F5F9' }}>{extractedData.tva}</span>

                  <span style={{ color: '#64748B' }}>Montant TTC :</span>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>{extractedData.ttc}</span>

                  <span style={{ color: '#64748B' }}>Catégorie :</span>
                  <span style={{ color: '#F59E0B' }}>{extractedData.category}</span>

                  <span style={{ color: '#64748B' }}>Compte PCG :</span>
                  <span style={{ color: '#38BDF8' }}>{extractedData.pcg}</span>
                </div>
                
                <div style={{ marginTop: 'auto', color: '#64748B', fontSize: '11px', borderTop: '1px solid #1E293B', paddingTop: '10px' }}>
                  ✓ Écriture comptable générée avec succès. Vos données restent privées et sécurisées dans votre espace dédié.
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* 5. PRICING SECTION */}
      <section id="pricing" className="pricing-section" style={{ background: '#FAF9F5', padding: '90px 24px', borderTop: '1px solid #E8E7E3' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <h2 style={{ fontSize: '36px', fontWeight: '800', color: '#0F172A', letterSpacing: '-0.8px', margin: 0 }}>
              Comparez nos offres & fonctionnalités
            </h2>
            <p style={{ fontSize: '16px', color: '#64748B', marginTop: '10px' }}>
              Des formules adaptées à chaque étape de votre entreprise. 30 jours d'essai gratuit, sans engagement.
            </p>
          </div>

          {/* Cartes d'offres principales */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px', marginBottom: '60px' }}>
            
            {/* Pack Liberté */}
            <div style={{
              background: 'white', border: '1px solid #E2E8F0', borderRadius: '20px', padding: '36px 28px',
              display: 'flex', flexDirection: 'column', gap: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.03)'
            }}>
              <div>
                <span style={{ fontSize: '12px', fontWeight: '700', color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Pack</span>
                <h3 style={{ fontSize: '22px', fontWeight: '800', color: '#0F172A', margin: '2px 0 6px' }}>Liberté</h3>
                <p style={{ fontSize: '13.5px', color: '#64748B', margin: 0 }}>Idéal pour micro-entrepreneurs & freelances</p>
              </div>

              <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                <span style={{ fontSize: '40px', fontWeight: '800', color: '#0F172A' }}>39 €</span>
                <span style={{ fontSize: '14px', color: '#64748B', fontWeight: '600' }}>HT / mois</span>
              </div>

              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '14px', color: '#334155' }}>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> Bilan & Compte de résultat préparatoires
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> Suivi & Déclarations de TVA
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> Facturation électronique Factur-X (Devis & Factures)
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> Télétransmission API au Portail Public (PPF)
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> Pilotage de trésorerie & Cash-flow
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#64748B' }}>✓</span> Conseil comptable & fiscal illimité 24/7
                </li>
              </ul>

              <button 
                onClick={onGoToRegister}
                style={{
                  marginTop: 'auto', padding: '14px', background: '#F8FAFC', color: '#0F172A', 
                  border: '1px solid #CBD5E1', borderRadius: '12px', fontSize: '14px', 
                  fontWeight: '700', cursor: 'pointer', transition: 'all 0.2s'
                }}
              >
                Essai gratuit 30 jours
              </button>
            </div>

            {/* Pack Sérénité (Recommandé) */}
            <div style={{
              background: 'white', border: '2px solid #10B981', borderRadius: '20px', padding: '36px 28px',
              display: 'flex', flexDirection: 'column', gap: '20px', position: 'relative',
              boxShadow: '0 12px 30px rgba(16, 185, 129, 0.12)'
            }}>
              <div style={{
                position: 'absolute', top: '-14px', right: '28px', background: '#10B981', color: 'white',
                fontSize: '11px', fontWeight: '800', padding: '4px 14px', borderRadius: '12px', letterSpacing: '0.5px'
              }}>
                RECOMMANDÉ
              </div>

              <div>
                <span style={{ fontSize: '12px', fontWeight: '700', color: '#10B981', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Pack</span>
                <h3 style={{ fontSize: '22px', fontWeight: '800', color: '#0F172A', margin: '2px 0 6px' }}>Sérénité</h3>
                <p style={{ fontSize: '13.5px', color: '#64748B', margin: 0 }}>Pour TPE & Sociétés (SAS, SARL, EURL)</p>
              </div>

              <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                <span style={{ fontSize: '40px', fontWeight: '800', color: '#0F172A' }}>79 €</span>
                <span style={{ fontSize: '14px', color: '#64748B', fontWeight: '600' }}>HT / mois</span>
              </div>

              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '14px', color: '#334155' }}>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> <strong>Tout le Pack Liberté inclus</strong>
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> <strong>Rapprochement bancaire automatique</strong>
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> Formalités juridiques annuelles (PV d'AG & Dépôt)
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> Édition fiches de paie & DSN (jusqu'à 3 salariés)
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> Détection automatique du bon taux de TVA
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> Gestion simplifiée des notes de frais & km
                </li>
              </ul>

              <button 
                onClick={onGoToRegister}
                style={{
                  marginTop: 'auto', padding: '14px', background: 'linear-gradient(135deg, #10B981, #059669)', 
                  color: 'white', border: 'none', borderRadius: '12px', fontSize: '14px', 
                  fontWeight: '700', cursor: 'pointer', boxShadow: '0 4px 14px rgba(16, 185, 129, 0.3)'
                }}
              >
                Essai gratuit 30 jours
              </button>
            </div>

            {/* Pack Exclusivité */}
            <div style={{
              background: 'white', border: '1px solid #E2E8F0', borderRadius: '20px', padding: '36px 28px',
              display: 'flex', flexDirection: 'column', gap: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.03)'
            }}>
              <div>
                <span style={{ fontSize: '12px', fontWeight: '700', color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Pack</span>
                <h3 style={{ fontSize: '22px', fontWeight: '800', color: '#0F172A', margin: '2px 0 6px' }}>Exclusivité</h3>
                <p style={{ fontSize: '13.5px', color: '#64748B', margin: 0 }}>Pour PME, Cabinets & Multi-sociétés</p>
              </div>

              <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                <span style={{ fontSize: '40px', fontWeight: '800', color: '#0F172A' }}>149 €</span>
                <span style={{ fontSize: '14px', color: '#64748B', fontWeight: '600' }}>HT / mois</span>
              </div>

              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '14px', color: '#334155' }}>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> <strong>Tout le Pack Sérénité inclus</strong>
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> <strong>Gestion Paie & DSN illimités</strong>
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> Multi-sociétés (jusqu'à 10 structures)
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> Optimisation fiscale de la rémunération du dirigeant
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> Diagnostic & contrôle d'intégrité du fichier FEC
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> Accès API dédié & intégrations sur-mesure
                </li>
              </ul>

              <button 
                onClick={onGoToRegister}
                style={{
                  marginTop: 'auto', padding: '14px', background: '#F8FAFC', color: '#0F172A', 
                  border: '1px solid #CBD5E1', borderRadius: '12px', fontSize: '14px', 
                  fontWeight: '700', cursor: 'pointer'
                }}
              >
                Essai gratuit 30 jours
              </button>
            </div>

          </div>

          {/* Tableau Comparatif détaillé Style Dougs */}
          <div style={{ marginTop: '70px', background: 'white', borderRadius: '24px', border: '1px solid #E2E8F0', padding: '32px 24px', overflowX: 'auto', boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
            <h3 style={{ fontSize: '24px', fontWeight: '800', color: '#0F172A', textAlign: 'center', marginBottom: '32px' }}>
              Tableau comparatif détaillé des prestations
            </h3>

            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', minWidth: '700px' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #E2E8F0' }}>
                  <th style={{ padding: '16px 20px', width: '40%', fontSize: '15px', color: '#0F172A', fontWeight: '800' }}>Prestations & Fonctionnalités</th>
                  <th style={{ padding: '16px 20px', textAlign: 'center', fontSize: '14px', color: '#0F172A', fontWeight: '700' }}>Pack Liberté<br/><span style={{ fontSize: '12px', color: '#64748B', fontWeight: 'normal' }}>39€ HT/mois</span></th>
                  <th style={{ padding: '16px 20px', textAlign: 'center', fontSize: '14px', color: '#10B981', fontWeight: '800' }}>Pack Sérénité<br/><span style={{ fontSize: '12px', color: '#64748B', fontWeight: 'normal' }}>79€ HT/mois</span></th>
                  <th style={{ padding: '16px 20px', textAlign: 'center', fontSize: '14px', color: '#0F172A', fontWeight: '700' }}>Pack Exclusivité<br/><span style={{ fontSize: '12px', color: '#64748B', fontWeight: 'normal' }}>149€ HT/mois</span></th>
                </tr>
              </thead>
              <tbody>

                {/* Section 1 : Prestations Comptables */}
                <tr style={{ background: '#F8FAFC' }}>
                  <td colSpan="4" style={{ padding: '14px 20px', fontWeight: '800', color: '#0369A1', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    📊 1. Prestations Comptables & Fiscales
                  </td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Bilan & Compte de résultat préparatoires transmis aux centres des impôts</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Déclaration de TVA (Suivi & préparation mensuelle/annuelle)</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Formalités juridiques annuelles (Rédaction du PV d'AG et Dépôt des comptes)</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#64748B', fontSize: '12px' }}>150 € HT</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓ Inclus</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓ Inclus</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Alertes d'échéances fiscales & déclaratives automatisées</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Exportation du Fichier des Écritures Comptables (FEC normé)</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                </tr>

                {/* Section 2 : Logiciel de comptabilité */}
                <tr style={{ background: '#F8FAFC' }}>
                  <td colSpan="4" style={{ padding: '14px 20px', fontWeight: '800', color: '#0369A1', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    💻 2. Logiciel de Comptabilité & Automatisations
                  </td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Comptabilité sans saisie manuelle (Importation bancaire)</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Catégorisation automatique des opérations bancaires au Plan Comptable</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Détection automatique et contrôle des taux de TVA appliquée</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Tableau de pilotage d'activité et indicateurs de performance en temps réel</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Numérisation des notes de frais & tickets avec extraction automatique</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Calculateur d'indemnités kilométriques (Barème officiel DGFIP)</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                </tr>

                {/* Section 3 : Facturation électronique */}
                <tr style={{ background: '#F8FAFC' }}>
                  <td colSpan="4" style={{ padding: '14px 20px', fontWeight: '800', color: '#0369A1', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    🧾 3. Facturation Électronique (Factur-X & Devis)
                  </td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Création de devis & factures au format Factur-X (EN16931)</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Conversion automatique de Devis validés en Factures en 1 clic</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Télétransmission API directe au Portail Public (PPF / Chorus Pro)</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Rapprochement automatique des factures avec les encaissements</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓</td>
                </tr>

                {/* Section 4 : Social, Paie & RH */}
                <tr style={{ background: '#F8FAFC' }}>
                  <td colSpan="4" style={{ padding: '14px 20px', fontWeight: '800', color: '#0369A1', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    👥 4. Social, Paie & RH
                  </td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Édition des fiches de paie & bulletins au format réglementaire</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#94A3B8' }}>—</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓ (Jusqu'à 3 salariés)</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓ Illimités</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Génération des fichiers DSN XML pour télédéclaration URSSAF</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#94A3B8' }}>—</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓ Inclus</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓ Inclus</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Gestion du personnel, contrats et conventions collectives</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#94A3B8' }}>—</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓ Inclus</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓ Inclus</td>
                </tr>

                {/* Section 5 : Accompagnement & Conseil */}
                <tr style={{ background: '#F8FAFC' }}>
                  <td colSpan="4" style={{ padding: '14px 20px', fontWeight: '800', color: '#0369A1', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    💬 5. Accompagnement & Conseil
                  </td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Conseil et assistance comptable, fiscale et juridique 24/7</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓ Illimité</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓ Illimité</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓ Illimité</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  <td style={{ padding: '14px 20px', fontSize: '13.5px', color: '#334155' }}>Optimisation fiscale de la rémunération et de la protection sociale du dirigeant</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#94A3B8' }}>—</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓ Inclus</td>
                  <td style={{ padding: '14px 20px', textAlign: 'center', color: '#10B981', fontWeight: 'bold' }}>✓ Avancée</td>
                </tr>

              </tbody>
            </table>
          </div>

        </div>
      </section>

      {/* 6. FOOTER */}
      <footer className="footer-section" style={{ background: '#0F172A', color: '#94A3B8', padding: '60px 40px', borderTop: '1px solid #1E293B', fontSize: '14px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', flexWrap: 'wrap', justifyItems: 'space-between', gap: '40px' }}>
          
          <div style={{ flex: '1 1 300px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{
                width: '30px', height: '30px', borderRadius: '8px', background: '#1D9E75',
                color: 'white', fontSize: '16px', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>
                C
              </div>
              <span style={{ fontSize: '18px', fontWeight: '700', color: 'white' }}>ComptaAI</span>
            </div>
            <p style={{ lineHeight: '1.6', maxWidth: '300px' }}>
              L'automatisation intelligente de la comptabilité pour les entreprises modernes. Sécurité et isolation garanties.
            </p>
          </div>

          <div style={{ flex: '1 1 200px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <span style={{ fontWeight: 'bold', color: 'white' }}>Solution</span>
            <a href="#features" style={{ color: '#94A3B8', textDecoration: 'none' }}>Fonctionnalités</a>
            <a href="#demo" style={{ color: '#94A3B8', textDecoration: 'none' }}>Démo</a>
            <a href="#pricing" style={{ color: '#94A3B8', textDecoration: 'none' }}>Forfaits</a>
          </div>

          <div style={{ flex: '1 1 200px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <span style={{ fontWeight: 'bold', color: 'white' }}>Sécurité</span>
            <span>Espaces de données isolés & étanches</span>
            <span>Contrôle d'accès strict</span>
            <span>Chiffrement de haute sécurité</span>
          </div>

          <div style={{ flex: '1 1 200px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <span style={{ fontWeight: 'bold', color: 'white' }}>Support</span>
            <span style={{ cursor: 'pointer' }} onClick={onGoToAdmin}>Espace Administrateur</span>
            <span style={{ cursor: 'pointer', color: '#94A3B8' }} onClick={onGoToConfidentialite}>Confidentialité</span>
            <span>contact@compta-ia-app.fr</span>
            <span>© 2026 ComptaAI. Tous droits réservés.</span>
          </div>

        </div>
      </footer>

    </div>
  );
};

export default HomePage;
